import { Pagination } from "react-admin";

export const StandardPagination = () => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
);
